import { render, staticRenderFns } from "./PaymentsHeader.vue?vue&type=template&id=4f85b496&scoped=true&"
import script from "./PaymentsHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85b496",
  null
  
)

export default component.exports